import { getFormDataFromObj } from "../utils/getFormDataFromObj";
import { bubble} from "../utils/bubble";

export class ApiClient {
    constructor(baseUrl = '') {
        if (!ApiClient.instance) {
            this.baseUrl = baseUrl || window.location.origin;
            ApiClient.instance = this;
        }
        return ApiClient.instance;
    }

    async request({
                      method = 'GET',
                      endpoint = '',
                      data = null,
                      headers = {},
                      dataType = 'json',
                      handleSuccess = this.handleSuccess,
                      handleError = this.handleError,
                      timeout = 7500,
                      isBubble = true,
                      excludedNames = [] // Параметр для исключений из FormData
                  }) {
        let url = endpoint;
        const options = {
            method: method,
            headers: { ...headers }
        };

        if (data) {
            if (method === 'GET') {
                url += '?' + this.convertDataToQueryString(data);
            } else {
                options.body = this.convertDataToBody(data, dataType, excludedNames);
                if (dataType === 'json') {
                    options.headers['Content-Type'] = 'application/json';
                } else if (dataType === 'form') {
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
                } else {
                    options.headers['Content-Type'] = 'text/plain';
                }
            }
        }

        const controller = new AbortController();
        const { signal } = controller;
        const timer = setTimeout(() => controller.abort(), timeout);

        try {
            const response = await fetch(url, { ...options, signal });
            clearTimeout(timer);

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            let responseData;
            if (dataType === 'json') {
                responseData = await response.json();
            } else {
                responseData = await response.text();
            }

            if (isBubble) {
                bubble(document.documentElement, requestSuccessBubble, { resp: responseData, cfg: { ...options, url } });
            }

            return handleSuccess(responseData);
        } catch (error) {
            clearTimeout(timer);
            handleError(error);
            console.error('Error:', error);
            throw new Error(`HTTP error! Status: ${error.message}`);
        }
    }

    convertDataToQueryString(data) {
        return new URLSearchParams(data).toString();
    }

    convertDataToBody(data, dataType, excludedNames) {
        if (data instanceof FormData) {
            return data;
        } else if (dataType === 'json') {
            return JSON.stringify(data);
        } else if (dataType === 'form') {
            const formData = getFormDataFromObj(data, new FormData(), excludedNames);
            return new URLSearchParams(formData).toString();
        } else {
            return data;
        }
    }

    handleSuccess(data) {
        console.log('Success:', data);
        return data;
    }

    handleError(error) {
        console.error('Request failed:', error);
        return { error: error.message };
    }
}

// Определение requestSuccessBubble
export const requestSuccessBubble = "requestSuccessfullyLoaded";
